<dashboard-loader
  *ngIf="(loadingTemplate$ | async) || (loadingIntervention$ | async)"
  [title]="'Loading template details...'"
></dashboard-loader>
<div class="dashboard-template-form" *ngIf="!isEdit || (templateLoaded$ | async)">
  <mat-checkbox
    class="dashboard-template-form__checkbox"
    *ngIf="isEdit"
    [checked]="selectedTemplate?.feedbackTemplateReady"
    (change)="setTemplateAsReady($event)"
    [disabled]="!selectedTemplate?.interventionId"
    [matTooltip]="
      selectedTemplate?.interventionId
        ? null
        : 'Please connect template with an intervention in order to continue working on it!'
    "
    matTooltipPosition="above"
  >
    <label
      class="dashboard-template-form__checkbox-label"
      *ngIf="!selectedTemplate?.feedbackTemplateReady; else templateReadyLabel"
    >
      Set template as ready to start sending feedback emails
    </label>
    <ng-template #templateReadyLabel>
      <label class="dashboard-template-form__checkbox-label">
        Template is already set as ready. Any further change will not affect participants who have already received
        feedback email.
      </label>
    </ng-template>
  </mat-checkbox>
  <form
    class="dashboard-template-form__form"
    [formGroup]="templateForm"
    dashboardConnectForm
    [connectForm]="selectedTemplate"
    fxLayout="column"
    fxLayoutGap="30px"
    fxLayoutAlign="center"
  >
    <mat-form-field fxFill>
      <input matInput formControlName="templateName" placeholder="Template Name" />
      <mat-error *ngIf="templateName.hasError('required')"> Template name is <strong>required</strong></mat-error>
    </mat-form-field>
    <div>
      <mat-tab-group
        mat-align-tabs="end"
        (selectedTabChange)="selectTemplateLanguage($event)"
        #languageTabs
        [disablePagination]="true"
        [selectedIndex]="selectedLanguage?.tabIndex"
        (animationDone)="selectFirstTab()"
      >
        <mat-tab *ngFor="let language of supportedLanguages" [label]="language?.name">
          <ng-container *ngTemplateOutlet="tabContent"></ng-container>
        </mat-tab>
      </mat-tab-group>
      <ng-template #tabContent>
        <div formArrayName="translations" *ngFor="let item of translations.controls; let i = index">
          <mat-form-field
            [formGroupName]="i"
            *ngIf="item.get('language').value === selectedLanguage?.code && item.get('identifier').value !== 'reminder'"
            fxFlex="100"
          >
            <input matInput formControlName="translation" [placeholder]="'Template Title'" />
            <mat-error
              *ngIf="item.get('identifier').value === 'title-main' && item.get('translation').hasError('required')"
            >
              Template title is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </ng-template>
    </div>

    <dashboard-image-upload
      formControlName="imageUrl"
      [uuid]="this.imageUploadUuid"
      [label]="'Logo'"
      [isEdit]="isEdit"
      [isImageToEdit]="isImageToEdit"
      [imgPath]="imgPath"
      [keyForUpload]="keyForUpload"
      [idsForUpload]="idsForUpload"
    >
    </dashboard-image-upload>
    <div fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="10px">
      <label class="dashboard-template-form__form-label">Languages</label>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxFlex="50">
          <mat-chip-list aria-label="Languages selection">
            <mat-chip
              selected
              color="accent"
              [removable]="true"
              (removed)="removeLanguage(selectedLanguage)"
              *ngFor="let selectedLanguage of supportedLanguages"
            >
              {{ selectedLanguage?.name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
        <div fxLayout="row" fxFlex="50" fxLayoutAlign="space-between stretch" fxLayoutGap="20px">
          <mat-form-field appearance="fill" fxFlex="100">
            <mat-label>Select language to add</mat-label>
            <mat-select (selectionChange)="selectLanguage($event.value)">
              <mat-option *ngFor="let language of languagesArray" [value]="language">
                {{ language.name | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-button color="primary" type="button" (click)="addLanguage()">
            {{ 'Add' | uppercase }}
          </button>
        </div>
      </div>
    </div>
    <mat-form-field appearance="fill">
      <mat-label>Select intervention</mat-label>
      <mat-select [value]="chosenIntervention" (selectionChange)="selectIntervention($event.value)">
        <mat-option *ngIf="isEdit && chosenIntervention" [value]="chosenIntervention">
          {{ chosenIntervention?.name | titlecase }}
        </mat-option>
        <mat-option *ngFor="let intervention of availableInterventions" [value]="intervention">
          {{ intervention.name | titlecase }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
  <div fxLayout="column" fxLayoutAlign="space-around end" fxFill>
    <button mat-raised-button color="accent" (click)="saveTemplate()">
      {{ 'Save Template' | uppercase }}
    </button>
  </div>
</div>
